import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { AvailabilityEnum } from 'common/features/Filters/predefined/Availability/store/availability.types';
import { actions } from 'stacks/ArtistProfile/ArtistProfileArtworks/store';
import { useArtistProfileArtworksAvailableFilterRoute } from 'stacks/ArtistProfile/hooks/useArtistProfileArtworksAvailableFilterRoute';
import useIsArtistProfileLoading from 'stacks/ArtistProfile/hooks/useIsArtistProfileLoading';
import { CUSTOM_DOMAIN_ROUTES } from 'routes/_definition';
import { Redirect } from 'react-router';

type ArtistAvailableArtProps = {
  artistContextId?: number;
};

const ArtistAvailableArt: React.FC<ArtistAvailableArtProps> = ({ artistContextId }) => {
  const dispatch = useDispatch();
  const { availableFilterSet } = useArtistProfileArtworksAvailableFilterRoute();
  const isArtistProfileLoading = useIsArtistProfileLoading(artistContextId);

  useEffect(() => {
    if (availableFilterSet || !isArtistProfileLoading) {
      return;
    }

    dispatch(actions.TOGGLE_AVAILABILITY_ArtistProfileArtworks({ availability: AvailabilityEnum.AVAILABLE }));
  }, [isArtistProfileLoading, availableFilterSet]);

  return <Redirect to={CUSTOM_DOMAIN_ROUTES.ROOT} />;
};

export default ArtistAvailableArt;
